module.exports = __webpack_public_path__ + "img/guardr_logo_upscaled.926c4cac.png";